module.exports = __webpack_public_path__ + "img/banner-demo-juve.57d8b3f2.jpg";